import { Icon as CXIcon, ICONS_ENUM as CXIconEnum } from '@sanlamcx/dsm-icons';

export const Icon = CXIcon;
export const ICONS_ENUM = CXIconEnum;
